<div class="card-action-menu" (click)="openMenu()">
  <svg-icon
    class="evergreen"
    src="assets/icons/icon-menu.svg"
    [ngClass]="{ 'parchment': iconThemeColor === 'parchment' }"
    aria-haspopup="true"
    [svgStyle]="{ 'width.em': 0.625, 'height.em': 1.125 }"
  ></svg-icon>
</div>

<ng-template #menu>
  <div class="custom-dropdown-menu" (click)="$event.stopPropagation()">
    <div
      *ngIf="canDelete"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'delete'"
      (click)="onActionClicked('delete')"
    >
      <span>DELETE</span>
      <svg-icon
        src="assets/icons/icon-trash.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.625, 'height.em': 0.625 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="canRemove"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'remove'"
      (click)="onActionClicked('remove')"
    >
      <span>REMOVE</span>
      <svg-icon
        src="assets/icons/icon-trash.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.625, 'height.em': 0.625 }"
      ></svg-icon>
    </div>
    <div
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'favorite'"
      (click)="onActionClicked('favorite')"
    >
      <span>FAVOURITE</span>
      <svg-icon
        src="assets/icons/icon-favorite-outline.svg"
        class="icon-forestpath"
        [class.favourite]="card.isPatientFavourite"   
        [svgStyle]="{ 'width.em': 0.625, 'height.em': 0.625 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="showSwap"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'swap'"
      (click)="onActionClicked('swap')"
    >
      <span>SWAP</span>
      <svg-icon
        src="assets/icons/icon-reuse.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.5625, 'height.em': 0.5625 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="isEditable && isCreate"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'create'"
      (click)="onActionClicked('create')"
    >
      <span>CREATE</span>
      <svg-icon
        src="assets/icons/icon-edit.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.59375, 'height.em': 0.46875 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="isEditable && !isCreate"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'edit'"
      (click)="onActionClicked('edit')"
    >
      <span>EDIT</span>
      <svg-icon
        src="assets/icons/icon-edit.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.59375, 'height.em': 0.46875 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="isEditable && canDuplicate"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'duplicate'"
      (click)="onActionClicked('duplicate')"
    >
      <span>DUPLICATE</span>
      <svg-icon
        src="assets/icons/icon-reuse.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.5625, 'height.em': 0.5625 }"
      ></svg-icon>
    </div>
  </div>
</ng-template>
